module.exports = __webpack_public_path__ + "img/newsImg10-1.e368ce92.png";